import Crear from "./Crear";


const paginas = { Crear };
export default paginas